module.exports = __webpack_public_path__ + "img/amazon-google-home.6b4cc552.jpg";